<template>
  <el-cascader
    class="department-cascade"
    v-model="selected"
    v-bind="$attrs"
    :options="$store.state.global.channels"
    @change="change"
  ></el-cascader>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      selected: []
    }
  },
  watch: {
    value(val) {
      this.selected = val
    }
  },
  created() {
    this.$store.dispatch('fetchChannels').then(jobs => { })
  },
  methods: {
    change(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" >
</style>
